<template>
  <div id="app">
    <router-view/>
    <CookieConsent />
  </div>
</template>

<script>
import { getFacebookAppId } from './environments'
import CookieConsent from '@/features/CookieConsent/index.vue'
/* global FB */
export default {
  name: 'App',
  components: {
    CookieConsent
  },

  created () {
    window.fbAsyncInit = () => {
      FB.init({
        appId: getFacebookAppId(),
        cookie: true,
        xfbml: true,
        version: 'v3.3'
      })
    }
    this.clearOldKycPersistForDeployNewVersion()
  },
  methods: {
    clearOldKycPersistForDeployNewVersion () {
      if (localStorage.getItem('persist:kyc-page')) {
        const deployTime = 1585927200000 // Fri Apr 03 2020 22:20:00 GMT+0700
        const persistExpTimestamp = JSON.parse(localStorage.getItem('persist:kyc-page')).expiration
        let persistDate = new Date(persistExpTimestamp)
        persistDate.setMonth(persistDate.getMonth() - 1)
        if (persistDate < deployTime) {
          localStorage.removeItem('persist:kyc-page')
        }
      }
    }
  }
}
</script>

<style lang="scss">
// Set global modal style
.modal-content {
  border-radius: 5px;
  max-height: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue